import {Component, inject, OnInit} from '@angular/core';
import {DialogButtonComponent} from '../../../../../../shared/common/dialog-button/dialog-button.component';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {RestErrorHelper} from '../../../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../../../service/player-profile.service';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {DialogHelper} from '../../../../../../shared/helper/dialog-helper';
import {ErrorType} from '../../../../../../../model/error-type';
import {LoadingComponent} from '../../../../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../../../../components/generic/message/message.component';
import {Mandant} from '../../../../../../../model/Mandant';
import {PortalService} from '../../../../../../../services/portal.service';
import {PrimeTemplate} from 'primeng/api';
import {Select} from 'primeng/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Divider} from 'primeng/divider';
import {InputText} from 'primeng/inputtext';
import {PlayerProfile} from '../../../../../model/player-profile';
import {environment} from '../../../../../../../../environments/environment';

@Component({
  selector: 'app-player-profile-add-links-dialog',
  imports: [
    DialogButtonComponent,
    TranslatePipe,
    LoadingComponent,
    MessageComponent,
    PrimeTemplate,
    Select,
    FormsModule,
    Divider,
    InputText,
    ReactiveFormsModule
  ],
  templateUrl: './player-profile-add-links-dialog.component.html',
  styleUrl: './player-profile-add-links-dialog.component.scss'
})
export class PlayerProfileAddLinksDialogComponent implements OnInit
{
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private restErrorHelper = inject(RestErrorHelper);
  private portalService = inject(PortalService);
  private playerProfileService = inject(PlayerProfileService);
  private translate = inject(TranslateService);

  isLoading: boolean;
  isSaving: boolean;
  errorMsg: ErrorType;
  playerProfile: PlayerProfile;

  mandantList: Mandant[];
  selectedMandant: Mandant;

  membershipNumber: string;
  noMembershipNumber = false;
  firstname: string;
  lastname: string;

  public static openDialog(dialogService: DialogService, playerProfile: PlayerProfile, translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      PlayerProfileAddLinksDialogComponent,
      DialogHelper.createBasicConfig({
        header: translate.instant('LINK_PLAYER'),
        width: DialogHelper.getDialogWidth(700),
        data: {playerProfile}
      }));
  }

  constructor()
  {
    this.playerProfile = this.config.data.playerProfile;
    this.loadClients();
  }

  ngOnInit(): void
  {
    this.firstname = this.playerProfile?.firstname;
    this.lastname = this.playerProfile?.lastname;
  }

  private loadClients(): void
  {
    if (this.isLoading)
      return;

    this.isLoading = true;
    this.errorMsg = undefined;
    this.portalService.getMandantsAssociations().subscribe({
      next: data =>
      {
        console.log('Mandanten erhalten', data);
        this.mandantList = data;
        this.sortMandantList();
        this.isLoading = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.isLoading = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  private sortMandantList(): void
  {
    if (this.mandantList)
    {
      this.mandantList.sort((data1, data2) =>
      {
        if (data2.mandantKey === 1758 && data1.mandantKey !== 1758)
          return 1;
        else if (data2.mandantKey !== 1758 && data1.mandantKey === 1758)
          return -1;
        else if ((data2.mandantKey === 561 && data1.mandantKey !== 561) ||
          (data2.mandantKey === 562 && data1.mandantKey !== 562) ||
          (data2.mandantKey === 563 && data1.mandantKey !== 563) ||
          (data2.mandantKey === 565 && data1.mandantKey !== 565) ||
          (data2.mandantKey === 566 && data1.mandantKey !== 566) ||
          (data2.mandantKey === 566 && data1.mandantKey !== 566) ||
          (data2.mandantKey === 567 && data1.mandantKey !== 567) ||
          (data2.mandantKey === 568 && data1.mandantKey !== 568) ||
          (data2.mandantKey === 570 && data1.mandantKey !== 570) ||
          (data2.mandantKey === 571 && data1.mandantKey !== 571) ||
          (data2.mandantKey === 572 && data1.mandantKey !== 572) ||
          (data2.mandantKey === 573 && data1.mandantKey !== 573) ||
          (data2.mandantKey === 575 && data1.mandantKey !== 575) ||
          (data2.mandantKey === 576 && data1.mandantKey !== 576) ||
          (data2.mandantKey === 577 && data1.mandantKey !== 577) ||
          (data2.mandantKey === 578 && data1.mandantKey !== 578) ||
          (data2.mandantKey === 579 && data1.mandantKey !== 579) ||
          (data2.mandantKey === 1895 && data1.mandantKey !== 1895) ||
          (data2.mandantKey === 2120 && data1.mandantKey !== 2120))
        {
          return 1;
        }
        else if ((data2.mandantKey !== 561 && data1.mandantKey === 561) ||
          (data2.mandantKey !== 562 && data1.mandantKey === 562) ||
          (data2.mandantKey !== 563 && data1.mandantKey === 563) ||
          (data2.mandantKey !== 565 && data1.mandantKey === 565) ||
          (data2.mandantKey !== 566 && data1.mandantKey === 566) ||
          (data2.mandantKey !== 566 && data1.mandantKey === 566) ||
          (data2.mandantKey !== 567 && data1.mandantKey === 567) ||
          (data2.mandantKey !== 568 && data1.mandantKey === 568) ||
          (data2.mandantKey !== 570 && data1.mandantKey === 570) ||
          (data2.mandantKey !== 571 && data1.mandantKey === 571) ||
          (data2.mandantKey !== 572 && data1.mandantKey === 572) ||
          (data2.mandantKey !== 573 && data1.mandantKey === 573) ||
          (data2.mandantKey !== 575 && data1.mandantKey === 575) ||
          (data2.mandantKey !== 576 && data1.mandantKey === 576) ||
          (data2.mandantKey !== 577 && data1.mandantKey === 577) ||
          (data2.mandantKey !== 578 && data1.mandantKey === 578) ||
          (data2.mandantKey !== 579 && data1.mandantKey === 579) ||
          (data2.mandantKey !== 1895 && data1.mandantKey === 1895) ||
          (data2.mandantKey !== 2120 && data1.mandantKey === 2120))
        {
          return -1;
        }

        return data1.name.localeCompare(data2.name);
      });

      console.log('Mandantenliste sortiert', this.mandantList);
    }
  }

  onOkClicked(): void
  {
    if (!(this.selectedMandant?.database?.databaseId >= 0))
      return;
    if (!((!this.noMembershipNumber && this.membershipNumber) || (this.noMembershipNumber && this.firstname && this.lastname)))
      return;

    this.isSaving = true;

    const body = {
      membershipNumber: this.noMembershipNumber ? undefined : +this.membershipNumber,
      firstname: this.firstname,
      lastname: this.lastname,
      databaseId: this.selectedMandant.database.databaseId,
      mandantKey: this.selectedMandant.mandantKey,
      mandantName: this.selectedMandant.name
    };

    this.playerProfileService.linkPlayer(body).subscribe({
      next: data =>
      {
        console.log('Einstellungen gespeichert', data);
        this.isSaving = false;
        this.ref.close(true);
        this.restErrorHelper.showInfoMessageService(this.translate.instant('PLAYER_PROFILE_LINKED_PLAYER_SUCCESS'),
          environment.toastDurationLong);
      },
      error: error =>
      {
        this.isSaving = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }

  onCancelClicked(): void
  {
    if (!this.isSaving)
      this.ref.close(false);
  }
}
